import { configureStore } from "@reduxjs/toolkit";
import {
  alert,
  app,
  auth,
  brand,
  contact,
  homeCarousel,
  order,
  products,
  promoCodes,
  promoCodesUsage,
  specialProducts,
  userReducer,
} from "./reducers";

const store = configureStore({
  reducer: {
    auth,
    app,
    promoCodes,
    products,
    brand,
    order,
    contact,
    promoCodesUsage,
    userReducer,
    homeCarousel,
    specialProducts,
    alert,
  },

  devTools: process.env.NODE_ENV === "production" ? false : true,
});

export default store;
